import TopInfo from "../../Components/TopInfo/TopInfo";
import Heading from "../../Components/Heading/Heading";
import React, { useRef, useState, useEffect } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import "./SayembaraVisual.scss";

import fotoJuara1 from "../../Assets/SayembaraVisual/Foto/Juara 1 -  SayembaraVisualOMB2023 - Pande Made Sabda Banyu - 81.jpg";
import fotoJuara2 from "../../Assets/SayembaraVisual/Foto/Juara 2 - SayembaraVisualOMB2023-Rakayodha Santana Y - 124.jpeg";
import fotoJuara3 from "../../Assets/SayembaraVisual/Foto/Juara 3 - SayembaraVisualOMB2023 - Aldi Pratama - 70.jpg";
import fotoNominasi1 from "../../Assets/SayembaraVisual/Foto/Nominasi - SayembaraVisualOMB2023 - Faturiansyah Ashindra Kusuma - 37.jpg";
import fotoNominasi2 from "../../Assets/SayembaraVisual/Foto/Nominasi - SayembaraVisualOMB2023 - Leonard Augusto Bantoro - 135.jpg";

import thumbnailVideo1 from "../../Assets/SayembaraVisual/Video/Thumbnail1.png";
import thumbnailVideo2 from "../../Assets/SayembaraVisual/Video/Thumbnail2.png";
import thumbnailVideo3 from "../../Assets/SayembaraVisual/Video/Thumbnail3.png";
import thumbnailVideo4 from "../../Assets/SayembaraVisual/Video/Thumbnail4.png";
import thumbnailVideo5 from "../../Assets/SayembaraVisual/Video/Thumbnail5.png";

import prev from "../../Assets/SayembaraVisual/prev-button.svg";
import next from "../../Assets/SayembaraVisual/next-button.svg";
import play from "../../Assets/SayembaraVisual/Play button.svg";

const fotoTerbaik = [
  {
    id: 1,
    img: fotoJuara1,
    ig: "@sabdabanyu",
    name: "Pande Made Sabda",
    position: "Terbaik 1"
  },
  {
    id: 2,
    img: fotoJuara2,
    ig: "@yodaaaahh",
    name: "Rakayodha Santana Y",
    position: "Terbaik 2"
  },
  {
    id: 3,
    img: fotoJuara3,
    ig: "@aldiyangyangg_",
    name: "Aldi Pratama",
    position: "Terbaik 3"
  },
  {
    id: 4,
    img: fotoNominasi1,
    ig: "@shibui.png",
    name: "Faturiansyah Ashindra",
    position: "<i>Runner Up</i>"
  },
  {
    id: 5,
    img: fotoNominasi2,
    ig: "@_leonardab",
    name: "Leonard Augusto",
    position: "<i>Runner Up</i>"
  }
];

const videoTerbaik = [
  {
    id: 1,
    ytEmbed: "https://youtu.be/fkiUgibR18g?si=6qjljEpwFxrZZbIt",
    ig: "@dcapss",
    name: "Leonardo Dicaprio",
    position: "Terbaik 1",
    thumbnail: thumbnailVideo1
  },
  {
    id: 2,
    ytEmbed: "https://youtu.be/vG8ULaKgMuc?si=clNWkOHO88zWLKH8",
    ig: "@wandyyyy.w",
    name: "Deswandy Wong",
    position: "Terbaik 2",
    thumbnail: thumbnailVideo2
  },
  {
    id: 3,
    ytEmbed: "https://youtu.be/mkcmNWVTzG8?si=92oidAfjdJ8gg9d_",
    ig: "@haru.panda_",
    name: "Samantha Olivia Gunawan",
    position: "Terbaik 3",
    thumbnail: thumbnailVideo3
  },
  {
    id: 4,
    ytEmbed: "https://youtu.be/ie-zrZ6QR8M?si=pW1v7BKHY5TOEIBb",
    ig: "@bro_eleazarr",
    name: "Eleazar Andrew",
    position: "<i>Runner Up</i>",
    thumbnail: thumbnailVideo4
  },
  {
    id: 5,
    ytEmbed: "https://youtube.com/shorts/CA9V4Qtk-qA?si=oEVU4NHvdcLQcXjo",
    ig: "@aukishariko66",
    name: "Louisa Clarence",
    position: "<i>Runner Up</i>",
    thumbnail: thumbnailVideo5
  }
];

const SayembaraVisual = () => {
  const swiperRef = useRef(null);
  const swiperRef2 = useRef(null);
  
  // MODAL
  const [modal, setModal] = useState(false);
  const Modal = useRef(null);
  const [foto, setFoto] = useState(null);

  function openModal(props){
      setModal(true);
      setFoto(props);
  }

  // HANDLE CLOSE MODAL
  useEffect(() => {
    const handleClickRemoveModal = (event) => {
      if (modal) {
        // Menutup modal jika area luar di-klik
        if (Modal.current && !Modal.current.contains(event.target)) {
          setModal(false);
        }
      }
    };
    document.addEventListener("click", handleClickRemoveModal, true);
    return () => {
      document.removeEventListener("click", handleClickRemoveModal, true);
    };
  }, [modal]);

  const nextPage = () => {
    if (swiperRef.current) swiperRef.current.slideNext();
  }
  const nextPage2 = () => {
    if (swiperRef2.current) swiperRef2.current.slideNext();
  }

  const prevPage = () => {
    if (swiperRef.current) swiperRef.current.slidePrev();
  }
  const prevPage2 = () => {
    if (swiperRef2.current) swiperRef2.current.slidePrev();
  }

  return (
    <>
      <div className="SayembaraVisual">
        <TopInfo />
        <Heading
          nama="Sayembara Visual"
          job="Kupu-kupu bidadari makan ikan buntal,<br/>
          Hadirlah kini Sayembara Visual!<br/><br/>
          Selamat menikmati guncangan kreativitas di bawah ini."
        />
        
        <div className="fotoTerbaik__section">
          <button className="prev-button" onClick={prevPage}><img src={prev} alt="" /></button>
          <button className="next-button" onClick={nextPage}><img src={next} alt="" /> </button>
          <div className="title-container">
            <p className="title">Foto Terbaik</p>
            <p className="title-details">Tekan untuk melihat secara penuh</p>
          </div>
          <Swiper 
            pagination={true} 
            navigation={true} 
            loop={true}
            modules={[Pagination, Navigation]} 
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            className="mySwiper swiperFotoTerbaik swiper1">
            {fotoTerbaik.map((foto) => {
              return(
                <SwiperSlide onClick={() => openModal(foto.img)} key={foto.id}>
                  <div className="overlay"></div>
                    <img src={foto.img} alt="" className="foto__terbaik" />
                  <div className="dataDiriPemenang">
                    <p className="instagram">{foto.ig}</p>
                    <div>
                      <h1 className="nama_peserta">{foto.name}</h1>
                      <button><p dangerouslySetInnerHTML={{ __html:foto.position }}></p></button>
                    </div>
                  </div>
                </SwiperSlide>
              );
            } )}
          </Swiper>
        </div>

        <div className="videoTerbaik__section">
          <button className="prev-button" onClick={prevPage2}><img src={prev} alt="" /></button>
          <button className="next-button" onClick={nextPage2}><img src={next} alt="" /> </button>
          <p className="title">Video Terbaik</p>
          <Swiper 
            pagination={true} 
            navigation={true} 
            loop={true}
            modules={[Pagination, Navigation]} 
            onSwiper={(swiper) => (swiperRef2.current = swiper)}
            className="mySwiper swiperFotoTerbaik swiper2">
            {videoTerbaik.map((video) => {
              return(
                <SwiperSlide key={video.id}>
                  <a href={video.ytEmbed} target="_blank" rel="noreferrer">
                    <button className="playButton">
                      <img src={play} alt="" />
                    </button>
                    <div className="overlay"></div>
                    <img src={video.thumbnail} alt=""/>
                    <div className="dataDiriPemenang">
                      <p>{video.ig}</p>
                      <div>
                        <h1>{video.name}</h1>
                        <button><p dangerouslySetInnerHTML={{ __html:video.position }}></p></button>
                      </div>
                    </div>
                  </a>
                </SwiperSlide>
              );
            } )}
          </Swiper>
        </div>

      </div> 
      {modal && (
          <div className="comingsoon" id="comingsoon">
              <div ref={Modal} className="modal-content">
                  <img className="foto" src={foto} alt="" />
              </div>
          </div>
      )}
    </>
  );
};

export { SayembaraVisual };